module.exports = __webpack_public_path__ + "assets/images/green-star.27f4c535b76d19620dd097d46ffd8025.svg";